module.exports = __webpack_public_path__ + "img/x-viewer.9da40079.svg";